import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getStoneEleByDateType } from '@/service/production/proReportAggregate';
export default function useGuliaoSaleData(params) {
  var stoneEle = ref({
    electric: 0,
    stonePro: 0,
    tonEle: 0,
    mainPro: 0,
    list: [],
    soil: {}
  });
  // 获取主机汇总数据
  var getStoneEleByDateTypeAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log(1212, params.value);
            _context.next = 3;
            return getStoneEleByDateType(params.value);
          case 3:
            data = _context.sent;
            stoneEle.value = data;
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getStoneEleByDateTypeAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [stoneEle, getStoneEleByDateTypeAsync];
}